// ProductDetails.js

import { useParams, Navigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import EnquireForm from "../../02-molecules/enquireForm/EnquireForm";
import comingSoon from "../../../assets/extras/coming-soon.jpg";
import SEO from "../../02-molecules/SEO/SEO";
import Breadcrumb from "../../01-atoms/breadcrumbs/Breadcrumbs";
import LikeButton from "../../02-molecules/likeButton/LikeButton";
import Share from "../../02-molecules/share/Share";

const ProductDetails = (props) => {
    const { productAssetArray, handleLoading } = props;
    const { productName } = useParams();

    const [showForm, setShowForm] = useState(false);
    const [mainCarousel, setmainCarousel] = useState(null);
    const [thumbnailCarousel, setthumbnailCarousel] = useState(null);
    
    // replaced '-' with space to match it with product name below
    const productNameFormatted = productName.replace(/-/g, ' ');

    const handleSubmit = (event) => {
        event.preventDefault();
        setShowForm(true);
    };

    let mainCarouselRef = useRef(null);
    let thumbnailCarouselRef = useRef(null);

    useEffect(() => {
        setmainCarousel(mainCarouselRef);
        setthumbnailCarousel(thumbnailCarouselRef);
    }, []);

    // settings for main carousel
    const mainCarouselSettings = {
        fade: true,
        waitForAnimate: false,
        lazyLoad: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    // arrows: false,
                }
            }
        ]
    }; 

    // settings for thumbnail carousel
    const thumbnailCarouselSettings = {
        infinite: true,
        swipeToSlide: true,
        focusOnSelect: true,
        // centerPadding: "20px",
        lazyLoad: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                }
            }
        ]
    };

    // Filter product based on the selected product
    const selectedProduct = productAssetArray.filter((product) => {
        return(
            product.product.fields.productName.toLowerCase() === productNameFormatted
        );
    })

    // If the selected product is empty, navigate to the 404 page
    if (selectedProduct.length === 0) {
        return <Navigate to="/404" />;
    }

    return(
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumb />

                <SEO
                    title={selectedProduct[0].product.fields.productName}
                    description={selectedProduct[0].product.fields.productDescription}
                    image={selectedProduct[0].images.length ? selectedProduct[0].images[0].fields.file.url : null}
                    name='Ajit Furniture House'
                    type='product'
                />

                <div className="content-container__product">
                    <div className="product-details">
                        <div className="product-details__content">
                            <div className="product-details__name">
                                <h2>{selectedProduct[0].product.fields.productName.toUpperCase()}</h2>
                                <Share />
                            </div>
                            
                            <div className="product-details__price">Starts at <span>₹{selectedProduct[0].product.fields.productPrice}</span><LikeButton selectedProduct={selectedProduct} /></div>
                            <p className="product-details__description">{selectedProduct[0].product.fields.productDescription}</p>

                            {/* <i className="fa-solid fa-chevron-right"></i> */}

                            <div className="product-details__enquire">
                                <p>Like this product and need more information?</p>
                                <button className="product-details__buy primary-button" onClick={handleSubmit}><span>Enquire Now</span></button>
                            </div>

                            {showForm
                            ? <EnquireForm selectedProduct={selectedProduct} setShowForm={setShowForm}/>
                            : null
                            }
                        </div>
                        
                        <div className="product-details__images">
                            {/* main carousel */}

                            {/* If there are more than 1 images, show the carousel */}
                            {selectedProduct[0].images.length > 1 ? 
                            <div className="product-details__images--carousel product-details__images--carousel-main">
                            <Slider 
                                asNavFor={selectedProduct[0].images.length > 2 ? thumbnailCarousel : null}
                                dots={selectedProduct[0].images.length <= 2 ? true : false}
                                ref={slider => (mainCarouselRef = slider)}
                                {...mainCarouselSettings}
                            >
                            {selectedProduct[0].images.map((image) => {
                                return(
                                    <div key={image.id} className="product-details__images--carousel-image">
                                        <div className="loading">
                                            <div className="loading-bar"></div>
                                        </div>

                                        <img loading="lazy" width={100} height={100} src={image.fields.file.url} alt={image.fields.title} onLoad={handleLoading} />
                                    </div>
                                )
                            })}
                            </Slider>
                            </div>

                            // If there is exactly 1 image, show it without the carousel
                            : selectedProduct[0].images.length === 1 ?
                            <img loading="lazy" width={100} height={100} src={selectedProduct[0].images[0].fields.file.url} alt={selectedProduct[0].images[0].fields.title} />

                            // If there are no images, show the "coming soon" image
                            : <img loading="lazy" width={100} height={100} src={comingSoon} alt={"coming soon"} />
                            }
                            
                            {/* thumbnail carousel */}
                            {selectedProduct[0].images.length > 2 ?
                            <div className="product-details__images--carousel product-details__images--carousel-thumbnail">
                            <Slider
                                asNavFor={mainCarousel} slidesToShow={selectedProduct[0].images.length}
                                ref={slider => (thumbnailCarouselRef = slider)}
                                {...thumbnailCarouselSettings}
                            >
                            {selectedProduct[0].images.map((image) => {
                                return(
                                    <div key={image.id} className="product-details__images--carousel-image">
                                        <div className="loading">
                                            <div className="loading-bar"></div>
                                        </div>

                                        <img loading="lazy" width={100} height={100} src={image.fields.file.url} alt={image.fields.title} onLoad={handleLoading} />
                                    </div>
                                )
                            })}
                            </Slider>
                            </div>
                            : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default ProductDetails;